import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { isRequired } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import TextInput from '../../../common/forms/input/TextInput';

export const IdlingConsumptionObservationForm = ({ handleSubmit, loading }) => {
  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Itinerario" required>
          <Field
            name="itineraryId"
            component={TextInput}
            placeholder="Itinerario"
            validate={[isRequired]}
            disabled
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Motivo" required>
          <Field
            name="idlingConsumptionMotiveId"
            component={TextInput}
            validate={[isRequired]}
            disabled
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Tiempo Parado (Minutos)" required>
          <Field
            name="idlingConsumptionTime"
            component={TextInput}
            validate={[isRequired]}
            disabled
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Galones Autorizados" required>
          <Field
            name="idlingConsumptionNumberOfGallon"
            component={TextInput}
            validate={[isRequired]}
            disabled
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Tiempo Parado Real (Minutos)" required>
          <Field
            name="realIdlingConsumptionTime"
            component={TextInput}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Galones Consumidos (Real)" required>
          <Field
            name="realIdlingConsumptionNumberOfGallon"
            component={TextInput}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Observación">
          <Field
            name="observation"
            component={TextInput}
            type="textarea"
            placeholder="Nota"
            disabled
          />
        </FormItem>
      </FormGroup>

      <FormFooter />
    </Form>
  );
};

IdlingConsumptionObservationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

IdlingConsumptionObservationForm.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => ({
  loading: !MechanicalMaintenanceUnit.BusMaintenanceStay.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'IdlingConsumptionObservationForm',
})(IdlingConsumptionObservationForm);

export default connect(mapStateToProps)(formComponent);
